<div class="navbar-container">
  <img (click)="goToDish()" class="dish-icon" src="./../../../../assets/images/icons/dish_logo.svg" alt="Dish Logo" />
  <mat-select (selectionChange)="onLanguageSelect($event)" [value]="selectedLanguage">
    <mat-option *ngFor="let l of languages" [value]="l">
      {{ l.toUpperCase() }}
    </mat-option>
  </mat-select>
</div>
